module.exports = __webpack_public_path__ + "img/gift-theOne-bottom.0812e26a.png";